import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useMobile } from '../../hooks/mediaHooks';

const AlphabetPage = ({ data, selectedLetter, setSelectedLetter, storeListTotal, isFirstPage, isLastPage, page, setPage }) => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    const isMobile = useMobile();

    const letters = ['All', ...alphabet];
    const totalLetters = letters.length;
    const itemsPerRow = Math.ceil(totalLetters / 2); // ensure exactly 2 rows on mobile

    // Contoh data item
    const containerMobileStyle = isMobile
        ? { display: 'grid', gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`, gap: '8px 6px', alignItems: 'center' }
        : {};

    const totalPages = Math.ceil(storeListTotal / 20);

    const getPageNumbers = () => {
        const candidates = new Set([0, totalPages - 1, page - 1, page, page + 1]);
        const validCandidates = Array.from(candidates)
            .filter((p) => p >= 0 && p < totalPages)
            .sort((a, b) => a - b);

        const result = [];
        for (let i = 0; i < validCandidates.length; i++) {
            if (i > 0 && validCandidates[i] - validCandidates[i - 1] > 1) {
                result.push('...');
            }
            result.push(validCandidates[i]);
        }
        return result;
    };

    return (
        <Container className="mb-5">
            {/* Header */}
            {/* <div className="mb-4">
        <h2 className="fw-normal mb-1" style={{ fontSize: '24px' }}>Perlengkapan Rumah</h2>
      </div> */}

            {/* Navigasi Alfabet */}
            {/* flex-wrap and gap-12 on mobile */}
            <div className="alphabet-container mb-5" style={containerMobileStyle}>
                {letters.map((char) => {
                    const mobileStyle = isMobile ? { textAlign: 'center', padding: '4px 2px', fontSize: '0.72rem', display: 'block' } : {};

                    return (
                        <span
                            key={char}
                            className={`alphabet-link ${selectedLetter === char ? 'active' : ''}`}
                            onClick={() => {
                                setSelectedLetter(char);
                                setPage(0);
                            }}
                            style={mobileStyle}
                        >
                            {char}
                        </span>
                    );
                })}
            </div>

            {/* Judul Huruf Aktif */}
            <h3 className="mb-5 fw-normal">{selectedLetter}</h3>

            {/* Grid Items (5 Kolom) */}
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-4 mt-2">
                {data?.length === 0 && <span className="text-gray-900">No Store Found</span>}
                {data?.map((item) => (
                    <Col key={item.id} as={Link} to={`/seller-store?storeid=${item.id}`} className="text-decoration-none">
                        <div className="text-center">
                            <div className="brand-card">
                                <img src={item.logo ? item.logo + '?width=110' : '/assets/images/no-image.png'} alt={item.name} />
                            </div>
                            <p className="mt-2 fw-medium text-dark">{item.businessName}</p>
                        </div>
                    </Col>
                ))}
            </Row>
            <ul className="pagination flex-center flex-wrap gap-16">
                {storeListTotal > 20 && !isFirstPage && (
                    <li className="page-item">
                        <Link
                            className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                            to="#"
                            onClick={() => setPage(page > 0 ? page - 1 : 0)}
                        >
                            <i className="ph-bold ph-arrow-left" />
                        </Link>
                    </li>
                )}
                {getPageNumbers().map((item, index) => {
                    if (item === '...') {
                        return (
                            <li className="page-item disabled" key={`ellipsis-${index}`}>
                                <span
                                    className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                    style={{ pointerEvents: 'none' }}
                                >
                                    ...
                                </span>
                            </li>
                        );
                    }
                    return (
                        <li className={`page-item ${page === item ? 'active' : ''}`} key={item}>
                            <Link
                                className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                to="#"
                                onClick={() => setPage(item)}
                            >
                                {String(item + 1).padStart(2, '0')}
                            </Link>
                        </li>
                    );
                })}

                {storeListTotal > 20 && !isLastPage && (
                    <li className="page-item">
                        <Link
                            className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                            to="#"
                            onClick={() => setPage(page + 1)}
                        >
                            <i className="ph-bold ph-arrow-right" />
                        </Link>
                    </li>
                )}
            </ul>
        </Container>
    );
};

export default AlphabetPage;
